import React from 'react';
import { PDFDownloadLink } from '@react-pdf/renderer';
import Button from 'components/0components/Button';

export default ({ document, fileName = 'export' }) => (<PDFDownloadLink document={document} fileName={`${fileName}.pdf`}>
    {({ loading }) => (loading ? 'Génération du document...' : <Button icon="fa-download">Télécharger</Button>)}
</PDFDownloadLink>);